import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormsModule, Validators } from '@angular/forms';
import { DynamicFieldModel, DynamicFormComponent } from '@share';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzInputModule } from 'ng-zorro-antd/input';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { HttpParams } from '@angular/common/http';
import { LoadingService } from 'src/app/share/services/loading.service';
import { PostTitleService } from './post-title.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-post-title',
  imports: [DynamicTableComponent, NzPopconfirmModule, NzInputModule, NzCardModule, NzTableModule, CommonModule, NzGridModule, FormsModule, NzButtonModule],
  providers: [NzModalService],
  templateUrl: './post-title.component.html',
  styleUrls: ['./post-title.component.scss']
})
export class PostTitleComponent implements OnInit {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Post Title List",
    permissionKey: "posttitle",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "small",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "title",
        title: "Post Title",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Post Title',
      name: 'title',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Post Title required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
  ];
  width: string;
  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly service: PostTitleService, private readonly cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.calculateWidth()
    
    forkJoin({
      postTitles: this.service.getItems()
    })
      .subscribe({
        next: ({ postTitles }) => {
          this.schema.columns[1].option = postTitles?.data.map((y: any) => ({
            text: y.title,
            value: y.title
          }));
        },
        error: err => console.error('Error loading post title options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }

  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.total;
      },
      error: err => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); },
      complete: () => { this.loadingService.toggleTableLoading(); this.cdr.detectChanges(); }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {

        }
      });

    }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
